var map = {
	"./camp.png": 1636,
	"./circle.svg": 1427,
	"./creative.png": 1637,
	"./frontend.png": 1638,
	"./gamedesign.png": 1639,
	"./graphicdesign.png": 1640,
	"./junior.png": 1641,
	"./math-3-4.png": 1642,
	"./math-5-6.png": 1643,
	"./pc.png": 1644,
	"./pytpro-nosnake.png": 1645,
	"./pytpro.png": 1646,
	"./pytstart-nosnake.png": 1647,
	"./pytstart.png": 1648,
	"./quadrangle.svg": 1425,
	"./unity.png": 1649,
	"./videocontent.png": 1650,
	"./websites.png": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1426;